import { Component, Input } from '@angular/core';
import { DatePipe, LowerCasePipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { InlineParamsComponent } from '@molecules/inline-params/inline-params.component';
import { InlineParamsItemComponent } from '@molecules/inline-params/inline-params-item/inline-params-item.component';
import { FirstCapitalPipe } from '@pipes/first-capital.pipe';
import { ThousandsPipe } from '@pipes/thousands.pipe';
import { CarItem } from '@models/car.model';

@Component({
  selector: 'app-car-detail-params',
  imports: [DatePipe, LowerCasePipe, TranslateModule, InlineParamsComponent, InlineParamsItemComponent, FirstCapitalPipe, ThousandsPipe],
  templateUrl: './car-detail-params.component.html',
  styleUrl: './car-detail-params.component.scss',
})
export class CarDetailParamsComponent {
  @Input() car?: CarItem;
}
